@use "variables" as *;

.icon {
  font-size: $fontSize-l !important;
}

.iconWrapper {
  padding-left: $search-bar-padding;
}

.input {
  font-size: $fontSize-m;
  font-weight: bold !important;
  padding-left: calc(#{$search-bar-padding} * 4);
  width: 100%;
}

.progressBar {
  border-radius: 10px;
  align-self: center;
}
